import React from 'react';
import { FaTimes } from 'react-icons/fa';
import { FiBell } from 'react-icons/fi';

const ProductSizeSelector = ({
  productData,
  size,
  setSize,
  showSizeChart,
  setShowSizeChart,
  handleNotifyMe,
}) => {
  const categoriesWithSizeChart = ['Bangles'];
  const BANGLE_SIZES = ['2.2', '2.4', '2.6', '2.8'];

  if (!productData.sizes || productData.sizes.length === 0) {
    return null;
  }

  return (
    <div className="flex flex-col gap-3 my-6">
      <div className="flex items-center gap-2">
        <p className="text-[#a75d5d] font-forum">Select Size</p>
        {/* ✅ Bell icon button, no text */}
        <button
          onClick={handleNotifyMe}
          className=" text-[#67000B] hover:text-[#a75d5d] transition"
          title="Notify Me"
        >
          <FiBell size={15} />
        </button>
      </div>

      <div className="flex flex-wrap gap-3">
        {BANGLE_SIZES.map((stdSize, index) => {
          const matchedSize = productData.sizes?.find((item) => item.size === stdSize);
          const isAvailable = matchedSize && matchedSize.quantity > 0;

          return (
            <div key={index} className="relative">
              <button
                onClick={() => isAvailable && setSize(stdSize)}
                disabled={!isAvailable}
                className={`relative border rounded-md text-xs px-3 py-1 w-10 h-10 flex items-center justify-center
            ${stdSize === size ? 'border-[#F0997D] bg-[#efc2c2]' : 'bg-gray-100'}
            ${!isAvailable ? 'opacity-60 cursor-not-allowed text-gray-500' : ''}
          `}
              >
                {stdSize}
                {!isAvailable && (
                  <span className="absolute inset-0 flex items-center justify-center pointer-events-none">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="gray"
                      strokeWidth="0.3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="w-full h-full absolute"
                    >
                      <line x1="0" y1="0" x2="24" y2="24" />
                      <line x1="24" y1="0" x2="0" y2="24" />
                    </svg>
                  </span>
                )}
              </button>
            </div>
          );
        })}
      </div>

      {categoriesWithSizeChart.includes(productData.category) && (
        <>
          <button
            onClick={() => setShowSizeChart(true)}
            className="font-forum mt-2 text-[#65000B] underline text-left w-full"
          >
            Size Chart
          </button>

          {showSizeChart && (
            <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 p-4">
              <div className="bg-white rounded-lg shadow-lg p-4 sm:p-6 w-full max-w-3xl max-h-[90vh] overflow-y-auto relative">
                <button
                  onClick={() => setShowSizeChart(false)}
                  className="absolute top-2 right-2 sm:top-4 sm:right-4 text-gray-600 hover:text-gray-900"
                >
                  <FaTimes size={18} />
                </button>

                <h2 className="text-xl font-forum font-semibold text-[#65000B] mb-4">
                  Bangle Size Chart
                </h2>

                <div className="overflow-x-auto text-sm -mx-2 sm:mx-0">
                  <table className="min-w-full border-collapse border border-gray-300">
                    <thead>
                      <tr className="bg-[#57030c] text-white">
                        <th className="border px-2 py-2">Size</th>
                        <th className="border px-2 py-2">Inner Diameter</th>
                        <th className="border px-2 py-2">Fits Wrist Circumference</th>
                        <th className="border px-2 py-2">CM</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[
                        { size: '2.2', diameter: '2.125″', wristCirc: '6.6″ – 6.8″', cm: '5.4 cm' },
                        { size: '2.4', diameter: '2.25″', wristCirc: '6.9″ – 7.1″', cm: '5.7 cm' },
                        { size: '2.6', diameter: '2.375″', wristCirc: '7.2″ – 7.4″', cm: '6.0 cm' },
                        { size: '2.8', diameter: '2.5″', wristCirc: '7.5″ – 7.7″', cm: '6.3 cm' },
                      ].map((row, idx) => (
                        <tr key={idx} className="text-center">
                          <td className="border px-2 py-2 font-semibold">{row.size}</td>
                          <td className="border px-2 py-2">{row.diameter}</td>
                          <td className="border px-2 py-2">{row.wristCirc}</td>
                          <td className="border px-2 py-2">{row.cm}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div className="mt-4 text-sm text-gray-600">
                  <p>
                    • <strong>How to measure:</strong> Measure the widest part of your hand (usually
                    knuckles), not your wrist.
                  </p>
                  <p>
                    • <strong>Inner diameter method:</strong> Place a well-fitting bangle on a ruler
                    and measure the inner diameter.
                  </p>
                  <p>
                    • <strong>String method:</strong> Wrap a string around the widest part of your
                    hand, mark where it overlaps, then measure.
                  </p>
                  <p>
                    • <strong>Size guide:</strong> 2.4 and 2.6 are the most commonly worn sizes
                    among Indian women.
                  </p>
                  <p>
                    • <strong>Fit preference:</strong> Choose smaller size for snug fit, larger for
                    comfortable loose fit.
                  </p>
                  <p>
                    • <strong>Between sizes:</strong> If you're between two sizes, choose the larger
                    one for comfort.
                  </p>
                </div>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ProductSizeSelector;
